import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { createUtm, deleteUtm, getUtms } from '../../services/pension'

const initialState = {
  error: null,
  loading: false,
  utms: [],
  status: 'idle'
}

/**
 * Create a new UTM record.
 */
export const onCreateUtmAsync = createAsyncThunk('adminPension/createUtm', async (payload, { dispatch }) => {
  const created = await createUtm(payload)
  dispatch(onGetUtmsAsync())
  return created
})

/**
 * Gets the list of utm's.
 */
export const onGetUtmsAsync = createAsyncThunk('adminPension/getUtms', async () => {
  const data = await getUtms()
  return data
})

/**
 * Delete a navigation option.
 */
export const onDeleteUtmAsync = createAsyncThunk('adminPension/deleteUtm', async ({ id }, { dispatch }) => {
  const response = await deleteUtm({ id })
  dispatch(onGetUtmsAsync())
  return response
})

export const utmSlice = createSlice({
  name: 'adminPension',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(onGetUtmsAsync.fulfilled, (state, action) => {
      state.loading = false
      state.utms = action.payload
    })
    builder.addCase(onDeleteUtmAsync.fulfilled, (state, action) => {
      state.utms = state.utms.filter((item) => item.id !== action.payload.id)
      state.status = 'fulfilled'
    })
  }
})

export default utmSlice.reducer
